import React from 'react';
import { ButtonStyled } from './Button.styles';

const Button = ({ ...buttonProps }) => {
  return <ButtonStyled {...buttonProps} />;
};

export default Button;
